require('./TweenMax');
require('./footer.js');
$(function () {

  progressBar();
  hovarHeaderMenuChild();
  mobileHeaderMenu();
  slideMenu();
  mobileSlideMenu();

  $(window).on('resize', function () {
    slideMenu();
    if ($('header nav ul').css('display') !== 'block') {
      closeMobileHeaderMenu();
    }
  });
});

/*
    ブログレスバー
====================================*/
function progressBar() {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.indexOf('iphone') > 0 || (ua.indexOf('android') > 0) && (ua.indexOf('mobile') > 0) || ua.indexOf('windows phone') > 0) {
    $('.progress-bar-wrap').addClass('mobile');
  } else {
    var tl = new TimelineMax();

    tl.to(".progress-bar", .8, {
      scaleX: 1,
      ease: Linear.easeNone
    });
  }
}

/*
    グローバルナビゲーションの子メニューをhoverした時に
    各メニューに紐づく画像を表示
====================================*/
function hovarHeaderMenuChild() {
  $('.menu-child-list li').on('mouseenter', function() {
    // hoverした時のメニューグループのリストの個数を取得
    var list_sum = $(this).parents('.menu-child-list').find('li').length;
    var no = 0;
    // メニュー分回して、hoverしたメニューが何番目なのかを取得
    for (var i = 1; i <= list_sum; i++) {
      // hover時のテキストとi番目のテキストが一致した場合のiを取得
      if ($(this).text() === $(this).parent().find('li:nth-of-type('+i+')').text()) {
        var no = i;
        break;
      }
    }
    // もしn番目の要素に紐づく画像イメージがactiveでなければ表示する画像を差し替える
    if ($(this).parents('.menu-child-list').next().find('div:nth-of-type('+no+')').attr('class') !== 'active') {
      $(this).parents('.menu-child-list').next().find('div').fadeOut().removeClass('active');
      $(this).parents('.menu-child-list').next().find('div:nth-of-type('+no+')').fadeIn().addClass('active');
    }
  });
}

/*
    ヘッダーメニュー
====================================*/
function mobileHeaderMenu() {
  $('.header-humberger').off();
  $('.header-humberger').on('click', function() {
    $('header nav').animate({right: 0}, 200, 'swing');
    $('html').addClass('mobile-menu-open');
  });

  $('.disable-container, .btn-close').off();
  $('.disable-container, .btn-close').on('click', function() {
    if ($('header nav ul').css('display') == 'block') {
      closeMobileHeaderMenu('close');
      return false;
    }
  });

  if ($('header nav ul').css('display') != 'block') {
    closeMobileHeaderMenu();
  }
}

/*
    モバイル時のサブメニューのアコーディオン表示
====================================*/
function mobileSlideMenu() {
  $('.header-menu > li > a:not(.btn-close)').on('click', function() {
    bp = getBreakpoint();
    if (bp <= 940) {
      if ($(this).hasClass('is-open')) {
        $(this).removeClass('is-open').next('div').slideUp();
      }
      else {
        $(this).addClass('is-open').next('div').slideDown();
      }
      return false;
    }
  });
}

/*
    サブメニューのアコーディオン表示
====================================*/
function slideMenu() {
  // タイマー初期化
  var timerId;
  // hover処理初期化
  $('.header-menu > li').off();
  // メニューをhoverしたら
  $('.header-menu > li').on({
    'mouseenter': function() {
      // PCの場合（display: flex）
      if ($('.header-menu').css('display') === 'flex') {
        if ($('.header-menu').hasClass('is-open')) { // すでにメニューが開いており、別のメニューを選択した場合
          // thisの値をthatに代入
          var that = this;
          // タイマーが起動する前の処理はしない
          if (timerId > 0) {
            clearTimeout(timerId);
          }
          // 0.3秒後に発火
          timerId = setTimeout(function() {
            // hoverしたメニューを表示し、他を非表示にする
            $('.header-menu-child').removeClass('active').stop().fadeOut();
            $(that).find('.header-menu-child').addClass('active').stop().fadeIn();
          }, 300);
        } else { // メニューが閉じている場合
          // thisの値をthatに代入
          var that = this;
          // タイマーが起動する前の処理はしない
          if (timerId > 0) {
            clearTimeout(timerId);
          }
          // 0.3秒後に発火
          timerId = setTimeout(function() {
            // activeクラスを追加してメニューをスライドで表示させる
            var header_height = getHeightHeaderMenu();
            $('.header-menu').addClass('is-open');
            $(that).find('.header-menu-child').addClass('active')
            $('.header-menu-child').css('height', header_height);
            $('.header-menu-child:not(".active")').css('display', 'none');
          }, 300);
        }
      }
    }
  });

  // メニューからhoverが外れたら
  $('.header-menu').on({
    'mouseleave': function() {
      // PCの場合（display: flex）
      if ($('.header-menu').css('display') === 'flex') {
        // タイマーが起動する前の処理はしない
        if (timerId > 0) {
          clearTimeout(timerId);
        }
        // 0.3秒後に発火
        timerId = setTimeout(function() {
          // スライドでメニューを閉じる
          $('.header-menu').removeClass('is-open');
          $('.header-menu-child').removeClass('active').removeAttr('style');
        }, 300);
      }
    }
  });

  // SPの場合
  $('.header-menu > li > a:not(.btn-close)').off();
  $('.header-menu > li > a:not(.btn-close)').on('click', function() {
    if ($('.header-menu').css('display') !== 'flex') {
      if ($(this).hasClass('active')) { // activeクラスがあればアコーディオンを閉じる
        $(this).removeClass('active').next('div').slideUp();
      }
      else { // activeクラスがなければアコーディオンを開く
        $(this).addClass('active').next('div').slideDown();
      }
      return false;
    }
  });
}

/*
    グロナビの高さを揃える
====================================*/
function getHeightHeaderMenu() {
  if ($('.header-menu').css('display') === 'flex') {
    // style属性を削除
    $('.header-menu-child').removeAttr('style');
    var maxHeight = 0;
    // もしdivがmaxHeightの値より大きい場合はdivの高さを全部合わせる
    $('.menu-warap').each(function() {
      if ($(this).height() > maxHeight) { maxHeight = $(this).outerHeight(); }
    });
    return maxHeight;
  } else {
    $('.header-menu-child').removeAttr('style');
  }
}

/*
    SP時のヘッダーメニューを閉じる
====================================*/
function closeMobileHeaderMenu(action) {
  if (action === 'close') {
    $('header nav').animate({right: '-280px'}, 200, 'swing');
    $('.header-menu-child').removeAttr('style');
  } else {
    $('header nav').css('right', '');
  }
  $('.header-menu a').removeClass('active');
  $('.header-menu').removeClass('is-open');
  $('.header-menu-child').removeClass('active').css({'opacity': '1'});
  $('html').removeClass('mobile-menu-open');
}

/*
    ブレークポイント取得
====================================*/
function getBreakpoint() {
  if (window.matchMedia('(min-width: 1200px)').matches) {
    return '1200';
  } else if (window.matchMedia('(min-width: 992px)').matches) {
    return '992';
  } else if (window.matchMedia('(min-width: 768px)').matches) {
    return '768';
  } else if (window.matchMedia('(min-width: 576px)').matches) {
    return '576';
  } else {
    return '575';
  }
}
